// An explicit empty value selects same-origin /api/docs; omit the variable to
// preserve the existing document service during the recovery rollout.
const configuredBase = process.env.VUE_APP_DOCS_API_BASE
const base = configuredBase === undefined ? 'https://vdsarticlecontents.vdsentnet.com' : configuredBase
export const DOCS_API_BASE = `${base.replace(/\/+$/, '')}/api/docs`
